import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class Person extends SmartModel {
	constructor(data) {
		super();

		this.birthDate = "0000-00-00 00:00:00";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.email = "";
		this.guid = "";
		this.firstName = "";
		this.lastName = "";
		this.phone = "";
		this.role = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.workPlace = "";
		this.updatedByGuid = "";

		// this.__birthDate = "0000-00-00";
		// this.__createdAt = "0000-00-00 00:00:00";
		// this.__fullName = "";
		// this.__passwordConfirm = "";
		// this.__permissions = {};
		// this.__preserveLogin = true;
		// this.__roles = "";
		// this.__showAgentFields = false;
		// this.__showInternalStaffFields = false;
		// this.__showSellRepresentativeFields = false;
		// this.__updatedAt = "0000-00-00 00:00:00";

		if (data) {
			this.import(data);
		}
	}

	// export(options) {
	// 	var exportData = {};


	// 	return exportData;
	// }

	// import (data, options) {
		// this.__import(data, options);

		// if (this.importDateField("birthDate", data.birthDate)) {
		// 	this.__birthDate = this.birthDate.format("YYYY-MM-DD");
		// 	this.__birthDateLabel = this.birthDate.format("DD/MM/YYYY");
		// }
		// this.importDateField("createdAt", data.createdAt);
		// this.importDateField("updatedAt", data.updatedAt);

		// if (data.preferences && data.preferences !== "[]" && data.preferences !== "" && typeof data.preferences === "string") {
		// 	this.preferences = Utils.parseJSON(data.preferences, "object");
		// }
		// else {
		// 	this.preferences = {
		// 		areaManagerGuid: "",
		// 		phoneExtension: "",
		// 		zones: ""
		// 	};
		// }

		// this.__fullName = `${this.firstName} ${this.lastName}`;

		// this.__showAgentFields = this.roles.indexOf("sellRepresentative") > -1 || this.roles.indexOf("areaManager") > -1 || this.roles.indexOf("projectManager") > -1;
		// this.__showSellRepresentativeFields = this.roles.indexOf("sellRepresentative") > -1;
		// this.__showInternalStaffFields = this.roles.indexOf("internalStaff") > -1;

		// this.password = "unchanged";
		// this.__passwordConfirm = "unchanged";
		// this.__hasThumbnailURL = this.pictureURL !== "";
	// }

}

Shark.registerModel("Person", Person);

export default Person;
